function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#gr)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M330.609 97.285C330.609 97.285 337.709 84.716 319.68 81.985C308.964 80.3287 297.999 81.652 287.985 85.81C287.985 85.81 300.554 70.51 280.885 63.952C261.216 57.394 240.993 72.695 240.993 72.695C240.993 72.695 260.666 36.082 245.365 33.35C230.064 30.618 221.865 46.465 221.865 46.465C221.865 46.465 223.503 1.10697 191.808 0.0149693C160.113 -1.07703 163.392 57.94 163.392 57.94C163.392 57.94 149.73 31.71 126.779 30.617C103.828 29.524 115.303 74.555 115.303 74.555C115.303 74.555 110.931 63.955 95.63 62.855C80.329 61.755 81.419 74.59 81.419 74.59C81.419 74.59 61.75 47.01 39.892 48.65C18.034 50.29 27.319 77.612 27.319 77.612C4.91897 75.973 -0.00402832 100.529 -0.00402832 100.529H346.457L330.609 97.285Z",
  fill: "#F4F4F4"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "gr"
}, /*#__PURE__*/React.createElement("rect", {
  width: 346.457,
  height: 100.53,
  fill: "white"
})));

var SvgGrass = function SvgGrass(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 347,
    height: 101,
    viewBox: "0 0 347 101",
    fill: "none",
    className: "block sm:hidden",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGrass, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Grass.d6436bfa.svg";
export { ForwardRef as ReactComponent };